import { useEffect, useState } from 'react'
import { Inbox } from 'lucide-react'
import { opcoApi } from '../../../services/api'
import { ALL_OPCOS_CODE, workspacePath } from '../../../config/opcoWorkspace'

// Shows how many requests have no OpCo yet (OpCo admins only). Hidden when
// there are none or the count cannot be loaded.
export default function UnassignedBanner() {
  const [count, setCount] = useState(null)

  useEffect(() => {
    let cancelled = false
    opcoApi.unassignedCount()
      .then((res) => {
        if (cancelled) return
        const n = Number(res?.data?.count)
        setCount(Number.isFinite(n) ? n : null)
      })
      .catch(() => { if (!cancelled) setCount(null) })
    return () => { cancelled = true }
  }, [])

  if (!count) return null

  // Unassigned requests are visible only in the All OpCos workspace; the link
  // is a full page load because switching workspace reloads the app.
  const href = workspacePath(ALL_OPCOS_CODE, `/requests?opco=${ALL_OPCOS_CODE}`)

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-800/60 dark:bg-amber-900/20 dark:text-amber-200"
    >
      <Inbox className="h-4 w-4 flex-shrink-0" />
      <span className="flex-1">
        <strong className="font-semibold">{count} unassigned {count === 1 ? 'request' : 'requests'}</strong>
        {' '}have no OpCo. Assign them by moving each request.
      </span>
      <a href={href} className="font-semibold underline-offset-2 hover:underline">
        View in All OpCos
      </a>
    </div>
  )
}
